export const AUTH = {
  loginForm: "auth-login-form",
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  submitBtn: "auth-submit-btn",
  errorAlert: "auth-error-alert",
  forgotLink: "auth-forgot-link",
  resetRequestForm: "auth-reset-request-form",
  resetRequestEmail: "auth-reset-request-email",
  resetRequestSubmit: "auth-reset-request-submit",
  resetConfirmForm: "auth-reset-confirm-form",
  resetConfirmToken: "auth-reset-confirm-token",
  resetConfirmPassword: "auth-reset-confirm-password",
  resetConfirmSubmit: "auth-reset-confirm-submit",
  logoutBtn: "auth-logout-btn",
};
